import { useSelector } from "react-redux";

import { dispatch } from "../../state/store";
import { setDarkMode } from "../../state/ducks";

import { strCode } from "../../consts";
import { t } from "../../services";

import { IconButton, SVG } from "../../components";
import { DarkModeWrapper } from "./styled";

const DarkModeSwitch = () => {
  const darkMode = useSelector((store) => store.global.darkMode);

  return (
    <DarkModeWrapper
      data-testid="dark-mode-wrapper"
      data-text={darkMode ? t(strCode.LIGHT_MODE_TOOLTIP) : t(strCode.DARK_MODE_TOOLTIP)}
    >
      <IconButton onClick={() => dispatch(setDarkMode(!darkMode))}>
        {darkMode ? <SVG.LightModeIcon /> : <SVG.DarkModeIcon />}
      </IconButton>
    </DarkModeWrapper>
  );
};

export default DarkModeSwitch;
